<template>
  <a-modal
    :width="900"
    :maskClosable="false"
    :keyboard="false"
    :visible="visible"
    @cancel="start"
  >
    <h2 slot="title" style="text-align:center">报名须知</h2>
    <div slot="footer">
      <a-checkbox @change="change">
        我已阅读并知悉以上内容
      </a-checkbox>

      <a-divider type="vertical"></a-divider>

      <a-button @click="start" type="primary">开始报名</a-button>
    </div>
    <div v-html="content">
    </div>
  </a-modal>
</template>
<script>
export default {
  name: "EventAppleNoticeModal",
  data() {
    return {
      visible: false,
      isAgree: false,
      content: ''
    };
  },
  methods: {
    show(content) {
      if(content == '' || content == null){
        return
      }
      this.visible = true;
      this.content = content
    },
    change(e){
        console.log(e);
        this.isAgree = e.target.checked
    },
    start() {
      if (this.isAgree) {
        this.visible = false;
      } else {
        this.$message.info("请阅读并勾选");
      }
    },
  },
};
</script>
<style scoped>
.qrcode {
  width: 100%;
}
</style>